import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { StakingRiskCardExistingShort } from "../../../Components/StakingRiskCard/existing_short";
import { StakingRiskCardExisting } from "../../../Components/StakingRiskCard/existing";
import { ZOOM_MAIN, ZOOM_MAIN_CLOSE } from "../../../Reducer/ZoomMainReducer";
import { FilterComponent } from "../../../Components/Filter";
import { AddStakingRiskModal } from "../../../Modal";
import { Header } from "../../../Components";
import {
  CreateStakingRiskProductByIDThunk,
  GetStakingRiskProductsUserInfoThunk,
} from "../../../Thunks/StakingRiskThunk";
import StakingRiskAside from "../../../Components/StakingRiskAside";
import active_list from "../../../Assets/img/icons/active_list.svg";
import zoom_minus from "../../../Assets/img/icons/zoom_minus.png";
import zoom_pluse from "../../../Assets/img/icons/zoom_plus.png";
import filter from "../../../Assets/img/icons/filter.svg";
import no_active from "../../../Assets/img/icons/a.svg";
import top from "../../../Assets/img/icons/to__top.svg";
import list from "../../../Assets/img/icons/list.svg";
import grid from "../../../Assets/img/icons/grid.svg";
import { categoriesConfig } from "../StakingRiskDetails/helper";

const cleanText = (value) => {
  if (!value) return "";

  return (
    value
      .toString()
      // HTML cleanup
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<[^>]*>/g, "")

      // Encoding normalization
      .replace(/–|—/g, "-") // en/em dash → hyphen
      .replace(/“|”/g, '"') // smart quotes
      .replace(/‘|’/g, "'")

      // CSV safety
      .replace(/\n+/g, " ")
      .replace(/"/g, '""')
      .trim()
  );
};

export function StakingRisk() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [stakedAmount, setStakedAmount] = useState("");
  const [tempProduct, setTempProduct] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [zoomActive, setZoomActive] = useState(() => {
    const saved = localStorage.getItem("zoomActive");
    return saved === "true"; // convert string to boolean
  });
  const [tab, showTab] = useState(1);

  const products = useSelector((state) => {
    return state.StakingRiskReducer.stakingRiskProductsListUserInfo;
  });
  const userStakingProductCreatedByIDSuccess = useSelector((state) => {
    return state.StakingRiskReducer.userStakingProductCreatedByIDSuccess;
  });

  const userStakingProductDeletedByIDSuccess = useSelector((state) => {
    return state.StakingRiskReducer.userStakingProductDeletedByIDSuccess;
  });
  const openMenu = useSelector((state) => state.menu.open);

  const zoom = () => {
    dispatch({ type: ZOOM_MAIN });
    setZoomActive(true);
    localStorage.setItem("zoomActive", "true");
  };

  const zoomClose = () => {
    dispatch({ type: ZOOM_MAIN_CLOSE });
    setZoomActive(false);
    localStorage.setItem("zoomActive", "false");
  };

  useEffect(() => {
    const handleScroll = (e) => {
      setShowTopBtn(e.target.scrollTop > 400);
    };
    const scrollContainer = document.getElementById("scrollContent");
    scrollContainer.addEventListener("scroll", handleScroll);

    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (
      userStakingProductCreatedByIDSuccess ||
      userStakingProductDeletedByIDSuccess
    ) {
      dispatch(GetStakingRiskProductsUserInfoThunk({ selected: true }));
    }
  }, [
    userStakingProductCreatedByIDSuccess,
    userStakingProductDeletedByIDSuccess,
    dispatch,
  ]);

  useEffect(() => {
    dispatch(GetStakingRiskProductsUserInfoThunk({ selected: true }));

    const intervalId = setInterval(() => {
      dispatch(GetStakingRiskProductsUserInfoThunk({ selected: true }));
    }, 15000); // 15second

    return () => clearInterval(intervalId);
  }, [zoomActive]);

  const { success } = useSelector((state) => {
    return state.StakingRiskReducer.createProductError;
  });

  useEffect(() => {
    if (products?.length === 0) {
      setIsOpen(true);
    }
  }, [products, zoomActive]);
  useEffect(() => {
    if (success === false) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [success, zoomActive]);
  const handleExportToExcel = async () => {
    setIsExporting(true);
    try {
      let csvContent = "";
      // Build headers
      const headers = ["Product Name", "Created Date", "Executive Summary", "Recommendation"];
      categoriesConfig.forEach((cat) => {
        cat.params.forEach((param) => {
          headers.push(`${cat.name}_${param}_Value`);
          headers.push(`${cat.name}_${param}_Comment`);
        });
        headers.push(`${cat.name}_TotalScore`);
        headers.push(`${cat.name}_RiskScore`);
        headers.push(`${cat.name}_WeightedScore`);
      });
      csvContent += headers.join(",") + "\r\n";

      // Build rows
      products.forEach((product) => {

        const row = [];
        row.push(`"${cleanText(product.stakingRisk.name)}"`);
        row.push(`"${cleanText(product.stakingRisk.createdAt)}"`);
        row.push(`"${cleanText(product.stakingRisk.info)}"`);
        row.push(`"${cleanText(product.stakingRisk.recommendation)}"`);

        categoriesConfig.forEach((cat) => {
          const categoryData =
            product.stakingRisk.stakingRiskClassifications.find(
              (c) => c.key === cat.key,
            );

          cat.params.forEach((param) => {
            const assessment = categoryData?.stakingRiskAssessments.find(
              (a) => a.key === param,
            );
            row.push(`"${cleanText(assessment?.scoreLevel)}"`);
            row.push(`"${cleanText(assessment?.comment)}"`);
          });

          if (categoryData) {
            const riskScore =
              categoryData.riskScoreType === "manual"
                ? categoryData.manualRiskScore
                : categoryData.automaticRiskScore;

            row.push(`"${categoryData.totalScore || "0"}"`);
            row.push(`"${riskScore || "0"}"`);
            row.push(`"${categoryData.weightedScore || "0"}"`);
          } else {
            // fallback if category not found
            row.push("0", "0", "0");
          }
        });

        csvContent += row.join(",") + "\r\n";
      });

      const BOM = "\uFEFF";
      const blob = new Blob([BOM + csvContent], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "staking_products_export.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <Header title="Staking Risk" />
      <main className={`main ${openMenu ? "open" : "main"}`}>
        <div className="content" id="scrollContent">
          <div className="row">
            {modalIsOpen && (
              <AddStakingRiskModal
                modalIsOpen={modalIsOpen}
                title="Staking Risk"
                modalClose={() => setIsOpen(false)}
                onProductSelect={(product) => setTempProduct(product)}
                stakedAmount={stakedAmount}
                setStakedAmount={setStakedAmount}
                onSaveProduct={() => {
                  if (tempProduct) {
                    const enrichedProduct = {
                      ...tempProduct,
                      stakedAmount: parseFloat(stakedAmount) || 0,
                    };
                    setSelectedProducts((prev) => [...prev, enrichedProduct]);
                    setTempProduct(null);
                    dispatch(
                      CreateStakingRiskProductByIDThunk(
                        enrichedProduct.id,
                        enrichedProduct.stakedAmount,
                      ),
                    );
                  }
                }}
              />
            )}

            {tab === 1 ? (
              products.map((product) => (
                <StakingRiskCardExisting
                  id={product.id}
                  key={product.id}
                  element={product}
                  reloadListCallback={() => { }}
                  zoomActive={zoomActive}
                />
              ))
            ) : (
              // List View
              <div className="content_list">
                <div className="row" style={{ gap: "20px 70px" }}>
                  {products.map((product) => (
                    <StakingRiskCardExistingShort
                      key={product.id}
                      product={product}
                      element={product}
                      reloadListCallback={() => { }}
                      zoomActive={zoomActive}
                    />
                  ))}
                </div>
              </div>
            )}

            <div className="layout__block">
              <img
                src={filter}
                alt=""
                className="filter__icon"
                onClick={() => {
                  setShowFilter(!showFilter);
                }}
              />
              <div
                className="layout__grid"
                onClick={() => {
                  showTab(1);
                }}
              >
                {tab === 1 ? (
                  <img src={grid} alt="" className="layout__grid__icon" />
                ) : (
                  <img src={no_active} alt="" className="layout__grid__icon" />
                )}
              </div>

              <FilterComponent
                activeclassName={showFilter ? "open" : "close"}
                urlpath={"/staking-risk"}
                showOnlyRiskFilter={true}
                onRiskFilterChange={(orderBy, order) => {
                  dispatch(
                    GetStakingRiskProductsUserInfoThunk({
                      orderBy,
                      order,
                      selected: true,
                    }),
                  );
                }}
              />
              <div
                className="layout__list"
                onClick={() => {
                  showTab(2);
                }}
              >
                {tab === 2 ? (
                  <img
                    src={active_list}
                    alt=""
                    className="layout__list__icon"
                  />
                ) : (
                  <img src={list} alt="" className="layout__list__icon" />
                )}
              </div>
              <div className="zoom__page__btn">
                <img
                  src={zoom_pluse}
                  width="24"
                  height="24"
                  alt=""
                  className="zoom__page__btn__plus"
                  onClick={zoomClose}
                />
                <img
                  src={zoom_minus}
                  width="24"
                  height="24"
                  alt=""
                  className="zoom__page__btn__minus"
                  onClick={zoom}
                />
              </div>
              <div
                className="layout__list"
                onClick={() => {
                  handleExportToExcel();
                }}
              >
                <span className="icon-export"></span>
              </div>
            </div>
          </div>
          {showTopBtn && (
            <a
              className="to__top"
              onClick={() => {
                document.getElementById("scrollContent").scrollTo(0, 0);
              }}
            >
              <img src={top} alt="top" className="to__top__icon" />
            </a>
          )}
        </div>
        <StakingRiskAside
          openModal={(event) => {
            setIsOpen(event);
          }}
        />
      </main>
    </>
  );
}
